import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tip" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", null, [
      _createTextVNode("⚠所有操作只在表格内有效,"),
      _createElementVNode("br"),
      _createTextVNode("请先选中数据区域(Ctrl+Shift+←↑↓→),"),
      _createElementVNode("br"),
      _createTextVNode("然后"),
      _createElementVNode("span", { style: {"color":"#ff9e02"} }, "套用表格格式"),
      _createTextVNode("转换成表格。 ")
    ], -1),
    _createElementVNode("div", null, "⚠表格除数据行外不要有多余的行或列，防止写入失败。", -1)
  ]))]))
}